export const SEO_DATA: Record<string, {
  title: string;
  description: string;
  canonicalUrl: string;
  imageUrl: string;
  structuredData?: any;
}> = {
  home: {
    title: 'arq-it | Tecnología para empresas que quieren crecer',
    description: 'Impulsa tu empresa con soluciones digitales a medida: automatización, desarrollo de software y modernización de tu infraestructura TI desde Chile.',
    canonicalUrl: 'https://www.dev.arq-it.cl/',
    imageUrl: 'https://www.dev.arq-it.cl/assets/img/preview-home.jpg',
    structuredData: {
      "@context": "https://schema.org",
      "@type": "Organization",
      "name": "arq-it",
      "url": "https://www.dev.arq-it.cl/",
      "logo": {
        "@type": "ImageObject",
        "url": "https://www.dev.arq-it.cl/assets/svg/logo.svg"
      },
      "sameAs": [
        "https://www.linkedin.com/company/arqit-cl/"
      ]
    }
  },

  about: {
    title: 'arq-it | Nuestro equipo y visión tecnológica',
    description: 'Somos un equipo multidisciplinario experto en tecnología, desarrollo y arquitectura TI. Creamos soluciones alineadas a tus objetivos de negocio.',
    canonicalUrl: 'https://www.dev.arq-it.cl/about',
    imageUrl: 'https://www.dev.arq-it.cl/assets/img/preview-home.jpg',
    structuredData: {
      "@context": "https://schema.org",
      "@type": "AboutPage",
      "name": "Sobre arq-it",
      "description": "Conoce a nuestro equipo experto en soluciones TI",
      "url": "https://www.dev.arq-it.cl/about"
    }
  },

  'arqit-services': {
    title: 'arq-it | Servicios TI a medida para tu negocio',
    description: 'Descubre nuestros servicios: desarrollo web, automatización, arquitectura TI y DevOps. Potencia tu empresa con soluciones escalables y personalizadas.',
    canonicalUrl: 'https://www.dev.arq-it.cl/arqit-services',
    imageUrl: 'https://www.dev.arq-it.cl/assets/img/preview-home.jpg',
    structuredData: {
      "@context": "https://schema.org",
      "@type": "Service",
      "name": "Servicios de Tecnología y Desarrollo TI",
      "provider": {
        "@type": "Organization",
        "name": "arq-it",
        "url": "https://www.dev.arq-it.cl/"
      },
      "url": "https://www.dev.arq-it.cl/arqit-services"
    }
  },

  contact: {
    title: 'arq-it | Hablemos sobre tus desafíos tecnológicos',
    description: '¿Buscas modernizar tu negocio con tecnología? Agenda una reunión con nuestro equipo y encuentra soluciones innovadoras, claras y accionables.',
    canonicalUrl: 'https://www.dev.arq-it.cl/contact',
    imageUrl: 'https://www.dev.arq-it.cl/assets/img/preview-home.jpg',
    structuredData: {
      "@context": "https://schema.org",
      "@type": "ContactPage",
      "name": "Contacto arq-it",
      "description": "Formulario de contacto para empresas que buscan soluciones digitales",
      "url": "https://www.dev.arq-it.cl/contact"
    }
  }
};
